// src/components/CookieConsent.jsx
// Baner zgody na cookies (RODO). Pokazuje się do czasu decyzji użytkownika,
// a wybór trafia do Google Consent Mode - dopóki go nie ma, GA4 i Google Ads
// mają zgody ustawione na "denied".
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { readConsent, saveConsent } from '../lib/consent';
import styles from '../css/modules/CookieConsent.module.css';

const CookieConsent = () => {
  // Startujemy jako niewidoczny, żeby prerenderowany HTML nie zawierał banera
  // przypiętego na stałe - decyzja zapada dopiero w przeglądarce.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (readConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = value => {
    saveConsent(value);
    setVisible(false);
  };

  return (
    <div
      className={styles.bar}
      role="dialog"
      aria-live="polite"
      aria-label="Zgoda na pliki cookie"
    >
      <div className={styles.inner}>
        <div className={styles.text}>
          <p className={styles.title}>Pliki cookie i Twoje dane</p>
          <p>
            Używamy plików cookie niezbędnych do działania serwisu oraz - za Twoją zgodą -
            plików analitycznych i marketingowych (Google Analytics, Google Ads), które
            pomagają nam mierzyć skuteczność strony. Administratorem danych jest{' '}
            <span className="dane-adm-nazwa" />, <span className="dane-adm-adres" />. Zgodę możesz wycofać w każdej chwili,
            czyszcząc dane strony w przeglądarce. Szczegóły znajdziesz w{' '}
            <Link to="/polityka-prywatnosci">polityce prywatności</Link>.
          </p>
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.accept} onClick={() => decide('granted')}>
            Akceptuję wszystkie
          </button>
          <button type="button" className={styles.reject} onClick={() => decide('denied')}>
            Tylko niezbędne
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
